<template>
    <b-container fluid>
        <Loading :active.sync="Loading"></Loading>
        <h2>Ingenieria</h2>
        <List :items="historico" :fields="fields" :urls="urls" :comentarios="comentarios" />
    </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    import {mapActions, mapState, mapGetters} from 'vuex'

    import List from '@/components/ingenieria/Historico'

    export default {
        name:'Historico',
        components:{
            Loading, List
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('ingenieria',['historico']),
            ...mapState('urls',['urls']),
            ...mapState('comentarioIng',['comentarios'])
        },
        data:function () {
            return{
                fields:[
                   
                    {key: 'id',label:'Folio',sortable:true},
                    {key: 'orden',label:'Prioridad',sortable:true},
                    {key: 'cliente', label:'Cliente',sortable:true},
                     {key:'acciones', label:'Acciones'},
                    {key:'producto', lable:'Producto',sortable:true},
                    {key:'cantidad', label:'Cantidad'},
                    {key:'trabajo', label:'Trabajo', sortable:true},
                    {key:'otro', label:'otro'},
                    {key:'fecha', label:'Fecha', sortable:true},
                    {key:'hora', label:'Hora'},
                    {key:'solicitante', label:'Solicitante', sortable:true},
                    {key:'url', label:'Link de archivo'},
                    {key:'observaciones',label:'Observaciones'},
                    {key:'comentario_ingenieria', label:'Observaciones Ingenieria'},
                    {key:'status',label:'Estado', sortable:true, variant: 'primary'},
                    {key:'preprensa',label:'Comentario de preprensa'},
                    {key:'ingenieria',label:'Comentario de ingenieria'},
                    {key:'create_at',label:'Creación'},
                    {key:'update_at',label:'Ultima Actualización'},
                   
                    ]
            }            
        },
        methods:{
            ...mapActions({
                _fetchHistorico: 'ingenieria/fetchHistorico',
                _fetchUrls: 'urls/fetchUrls',
                _comentarios: 'comentarioIng/fetchComentarios'
            }),
            init(){
                this._fetchHistorico()
                this._fetchUrls()   
                this._comentarios()
            }
        }
        
    }
</script>

<style lang="scss" scoped>

</style>